module.exports = __webpack_public_path__ + "static/media/s_green_1.17a17669.mp3";